<ng-container class="fullwidth">
  <ion-list class="margin-left-right-1 margin-top-bottom-10" [inset]="true">
    <ion-item [button]="true" [detail]="false" (click)="openModal()">
      <ion-label class="single-select-header">
        @if (isTenantSelection()) {
          Tenant:
        } @else {
          Deployment:
        }
      </ion-label>
      @if (hasOptions()) {
        <div class="single-select-value" id="selected-value" slot="end">
          @if (isTenantSelection()) {
            {{ this.deploymentStore.selectedTenant()?.name }}
          } @else {
            {{ this.deploymentStore.selectedDeployment()?.name }}
          }
        </div>
        <div class="single-select-value" id="selected-value-icon" slot="end">
          <ion-icon name="chevron-down-outline" />
        </div>
      } @else {
        <div class="single-select-value" id="selected-value-not-available" slot="end">
          No data available
          @if (!isTenantSelection()) {
            <sup class="ion-padding-start">With configured device & address</sup>
          }
        </div>
      }
    </ion-item>


  </ion-list>
</ng-container>
